import React, { useEffect, useRef } from 'react'
import { IFomItemSize } from '../FormItemEx/interface'
import './index.less'

interface IProps{
    size?:IFomItemSize
    color?:any,
    className?:any
}

export const Loading = (props:IProps)=>{

    const loadingRef = useRef<any>()
    
    useEffect(()=>{
        if(loadingRef.current){
            // 修改伪类颜色
            const style = document.createElement("style");
            document.head.appendChild(style);
            let  sheet:any = style.sheet
            sheet.addRule('.zc-loading::before',`background-color: ${props.color}`);
            sheet.insertRule(`.zc-loading::before { background-color:  ${props.color} }`, 0);
            sheet.addRule('.zc-loading::after',`background-color: ${props.color}`);
            sheet.insertRule(`.zc-loading::after { background-color:  ${props.color} }`, 0);
            loadingRef.current.setAttribute('data-content','red')
        }
    },[loadingRef.current])



    return (<div className={`zc-loading ${props.className}`} ref={loadingRef}/>)
}